import { render, staticRenderFns } from "./view-tag.vue?vue&type=template&id=39716c80&scoped=true&"
import script from "./view-tag.vue?vue&type=script&lang=ts&"
export * from "./view-tag.vue?vue&type=script&lang=ts&"
import style0 from "./view-tag.vue?vue&type=style&index=0&id=39716c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39716c80",
  null
  
)

export default component.exports